import { z } from 'zod';

export const CustomerProfileFormSchema = z.object({
	name: z
		.string()
		.min(1, 'Name is required')
		.max(100, 'Name must be less than 100 characters'),
	description: z.string().min(1, 'Description is required'),
	customer_keywords: z.array(z.string()).optional().default([]),
	customer_tones: z.array(z.string()).min(1, 'At least one tone is required'),
	customer_rules: z
		.array(z.string())
		.min(1, 'At least one condition is required'), // Array of condition IDs
});

export type ICustomerProfileForm = z.infer<typeof CustomerProfileFormSchema>;

// Form data type for creating (without server-generated fields)
export interface ICustomerProfileCreateForm extends ICustomerProfileForm {}

// Form data type for editing (includes ID)
export interface ICustomerProfileEditForm extends ICustomerProfileForm {
	_id: string;
}
